// src/routes/AppRoutes.tsx
import React from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import ProtectedRoute from '../components/ProtectedRoute';
import LoginPage from '../pages/LoginPage';
import TopMenu from '../pages/TopMenu';
import UnauthorizedPage from '../pages/UnauthorizedPage';
import AgoraStandardMeeting from '../components/Tabs/AgoraStandardMeeting';
import AgoraMimamoriMeeting from '../components/Tabs/AgoraMimamoriMeeting';
import Mimamori_Agora_Meeting from '../components/Tabs/Mimamori_Agora_Meeting';
import AlbumImportPage from '../pages/AlbumImportPage';
import { useAuth } from '../context/AuthContext';
import { ADMIN_ROLE } from '../constants/roles';

// CSSファイルの確実な読み込みのために追加
import '../styles/login.css';
import '../styles/global.css';
import '../styles/index.css';

const AppRoutes: React.FC = () => {
  const { loading } = useAuth();
  const location = useLocation();

  // ローディング中の表示（アルバムQRインポートは認証不要のため待たない）
  if (loading && location.pathname !== '/album-import') {
    return (
      <div className="loading-container">
        <div className="loading-spinner"></div>
        <p>読み込み中...</p>
      </div>
    );
  }

  return (
    <Routes>
      {/* ========================================
          🔓 認証が不要な公開ルート（重要：上位に配置）
         ======================================== */}
      
      {/* ログイン・認証関連 */}
      <Route path="/login" element={<LoginPage />} />
      <Route path="/unauthorized" element={<UnauthorizedPage />} />
      <Route path="/album-import" element={<AlbumImportPage />} />

      <Route element={<ProtectedRoute requiredRoles={[ADMIN_ROLE]} />}>
        <Route path="/mimamori-agora/:emergencyId" element={<Mimamori_Agora_Meeting />} />
        <Route path="/standard-meeting/:channelId" element={<AgoraStandardMeeting />} />
        <Route path="/mimamori-meeting/:channelId" element={<AgoraMimamoriMeeting />} />
        <Route path="/" element={<TopMenu />} />
        <Route path="/admin" element={<div>管理者ページ</div>} />
      </Route>
      
      {/* ========================================
          ❌ 未定義のルート処理（最後に配置）
         ======================================== */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

export default AppRoutes;